import React, { useRef } from 'react';
import { getLabel } from '../data/labels';

function GoUpParag(props) {
    function handleClick(event) {
        if(props?.refScrollableContainer?.current) {
            window.$(props.refScrollableContainer.current).animate({scrollTop: 0}, 800);
        }else{
            window.$(event.currentTarget.parentElement).animate({scrollTop: 0}, 800);
        }
    }

    const el = useRef(null);
    
    return (

        <div ref={el}  onClick={handleClick} className="back-to-top d-flex flex-column align-items-center justify-content-center margine-giu-2x margine-su grigio-scuro">
                <p className="grassetto maiuscolo torna-su margine-giu-mezzo">{getLabel('general.go_up_box.end_of_list')}</p>
                <p className="pointer torna-su">{getLabel('general.go_up_box.go_back_up')} <i className="fas fa-arrow-up"></i></p>
          </div>
    );
}

export default GoUpParag;